var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-tabs",class:{
    'scroll-x': _vm.scroll,
    'btns': _vm.type == 'btns',
    'links': _vm.type == 'links'
  }},_vm._l((_vm.tabs),function(tab){return _c('a',{key:tab[_vm.param],staticClass:"sm-tabs__item",class:{
      'active': tab == _vm.currentTab,
      'sm-h4': _vm.type == 'btns',
      'sm-h5': _vm.type == 'links',
      'disabled': tab.disabled,
      'hidden': tab.hidden
    },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchTab(tab)}}},[_vm._v(" "+_vm._s(tab.text)+" "),(tab.items)?_c('span',{staticClass:"sm-tabs__item-qty"},[_vm._v(_vm._s(tab.items))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }